export const SAVED_VIEWS_URL = 'saved-views'
